import { useNavigate, useLocation } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { Item } from "./Item";
import { Typography, Box } from "@mui/material";
import { useContext } from "react";
import { ChartsContext } from "../ChartsContext";

interface Props {
  title: string;
}

export function ReturnBar({ title }: Props): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { survey } = useContext(ChartsContext);
  const today = new Date();
  
  const handleGoBack = () => {
    // Verificar si la survey tiene template
    const hasTemplate = survey?.templateName && survey.templateName.trim() !== "";
    
    // Obtener la ruta actual
    const currentPath = location.pathname;
    
    // Si estamos en overview, siempre ir a home
    if (currentPath.includes('/overview')) {
      navigate('/');
      return;
    }
    
    // Si estamos en questions-data o comparative-information
    if (currentPath.includes('/questions-data') || currentPath.includes('/comparative-information')) {
      if (hasTemplate) {
        // Survey con template: volver a overview
        const surveyId = currentPath.split('/')[2]; // extraer el ID de la survey
        navigate(`/charts/${surveyId}/overview`);
      } else {
        // Survey custom: ir a home
        navigate('/');
      }
      return;
    }
    
    // Por defecto, ir a home
    navigate('/');
  };
  
  return (
    <>
      <Box 
        display="flex"
        flexDirection="row"
        alignItems="center"
        bgcolor="white"
        padding={{ xs: "12px 16px", sm: "16px 20px", md: "16px 24px" }}
        marginBottom="20px"
        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
        borderRadius="8px"
        border="1px solid #e0e0e0"
      >
        <Box 
          display="flex" 
          flexDirection="column" 
          flex={1}
        >
          <Box display="flex" alignItems="center" marginBottom="4px" onClick={handleGoBack} style={{ cursor: 'pointer' }}>
            <ArrowBackIcon 
              sx={{ 
                fontSize: { xs: '20px', sm: '22px', md: '24px' },
                color: '#1A237E',
                marginRight: { xs: '8px', sm: '10px', md: '12px' }
              }} 
            />
            <Typography 
              fontSize={{ xs: "18px", sm: "20px", md: "22px" }}
              fontFamily="IBM Plex Sans" 
              fontWeight="600" 
              color="#1A237E"
              lineHeight="1.2"
            >
              {title}
            </Typography>
          </Box>
          <Typography 
            fontSize={{ xs: "12px", sm: "13px", md: "14px" }}
            fontFamily="IBM Plex Sans" 
            fontWeight="400" 
            color="#5f6368"
            marginLeft={{ xs: "28px", sm: "32px", md: "36px" }}
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            {today.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
